<div class="annual-hero-bg">
    <section class="annual-hero-section container">
        <div class="glass-panel-container">
            <div class="row align-items-center">
                <div class="col-lg-5 hero-content-col">
                    <h1 class="banner-heading-one">Blog</h1>
                    <nav aria-label="breadcrumb" class="breadcrumb-nav">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item">
                                <a routerLink="/">Home</a>
                            </li>
                            <li class="breadcrumb-item active" aria-current="page">Blog</li>
                        </ol>
                    </nav>
                </div>
                <div class="col-lg-7 hero-image-col">
                    <img src="../../../../assets/resources/blog/blog-bannerimage.png" alt="Blog Illustration"
                        class="hero-image">
                </div>
            </div>
        </div>
    </section>
</div>

<!-- Blog List Section -->
<div class="blogs-list-section">
    <div class="container">
        <h2 class="section-title">Know About Our Blogs</h2>

        <div class="row g-4">
            <!-- Loop through the blogs array -->
            <div class="col-lg-4 col-md-6" *ngFor="let blog of blogs">
                <!-- ADDED data-aos="fade-up" HERE -->
                <div class="blog-card h-100" (click)="nav(blog.navLink)" data-aos="fade-up">
                    <div class="card-image-wrapper">
                        <img [src]="blog.image" [alt]="blog.title" class="card-image">
                        <div class="badge-overlay">{{ blog.timeToRead }}</div>
                    </div>
                    <div class="card-content">
                        <div class="info-wrapper">
                            <h6 class="card-title">{{ blog.title }}</h6>
                            <div class="card-meta">
                                <i class="ri-calendar-line"></i>Posted on {{ blog.postedOn | date:'dd MMM yyyy' }}
                            </div>
                        </div>
                        <div class="arrow-icon-wrapper">
                            <i class="ri-arrow-right-line"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>